function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import { readTextFile } from "../../utils";
import { EDITOR_MODE, EVENT, LAYOUT_NAMES } from "../../utils/constants";
import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, Icon, MenuItem, OverflowMenu, Popover, SelectItem, useTheme, View, wrapComponent } from 'unitx-ui';
import Form from 'unitx-ui/components/Form';
import * as R from 'unitx/ramda';
import { DocumentPicker } from 'unitx-ui/@/DocumentPicker';
import Recorder from 'unitx-ui/components/Recorder';
import useAnimation, { animated } from 'unitx-ui/hooks/useAnimation';
export const ACTION = {
  EXPORT_DATA: 'EXPORT_DATA'
};
const DEFAULT_ACTIONS = {
  add: {
    visible: true
  },
  delete: {
    visible: true
  },
  options: {
    actions: {
      import: {
        visible: true
      }
    }
  },
  layout: {
    visible: true
  }
};
const RECORDING_STATUS_MAP = {
  START: 'START',
  STOP: 'STOP',
  RECORDING: 'RECORDING',
  IDLE: 'IDLE'
};
const HEIGHT = 40;
const AnimatedSurface = animated(View);

const ActionBar = props => {
  var _props$actions;

  const {
    onEvent,
    renderMoreAction,
    mode,
    opened,
    recording = false,
    // recordingActions = false,
    graphEditorRef,
    graphConfig,
    onAction
  } = props;
  const {
    props: animatedProps,
    ref: animationRef
  } = useAnimation({
    from: {
      bottom: -HEIGHT
    },
    to: {
      bottom: 0
    },
    autoStart: false
  }); // const initialized = React.useRef(false)

  React.useEffect(() => {
    animationRef.current.reverse({
      reversed: !opened
    });
  }, [animationRef, opened]);
  const createOnActionCallback = React.useCallback((type, extraData) => // @ts-ignore
  () => onEvent === null || onEvent === void 0 ? void 0 : onEvent({
    type,
    extraData
  }), [onEvent]);
  const theme = useTheme();
  const recordingRef = React.useRef(RECORDING_STATUS_MAP.IDLE);
  React.useMemo(() => {
    switch (recordingRef.current) {
      case RECORDING_STATUS_MAP.IDLE:
        recordingRef.current = recording ? RECORDING_STATUS_MAP.START : RECORDING_STATUS_MAP.IDLE;
        break;

      case RECORDING_STATUS_MAP.START:
        recordingRef.current = recording ? RECORDING_STATUS_MAP.RECORDING : RECORDING_STATUS_MAP.STOP;
        break;

      case RECORDING_STATUS_MAP.RECORDING:
        recordingRef.current = recording ? RECORDING_STATUS_MAP.RECORDING : RECORDING_STATUS_MAP.STOP;
        break;

      case RECORDING_STATUS_MAP.STOP:
        recordingRef.current = recording ? RECORDING_STATUS_MAP.START : RECORDING_STATUS_MAP.IDLE;
        break;

      default:
        break;
    }
  }, [recording]); // React.useEffect(() => {
  //   animationRef?.current?.start()
  // }, [])

  const actions = R.mergeDeepRight(DEFAULT_ACTIONS, (_props$actions = props.actions) !== null && _props$actions !== void 0 ? _props$actions : {});
  return /*#__PURE__*/React.createElement(AnimatedSurface, {
    style: _objectSpread({
      position: 'absolute',
      width: '100%',
      height: HEIGHT,
      left: 0,
      flexDirection: 'row',
      // @ts-ignore
      backgroundColor: theme.colors.surface
    }, animatedProps)
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: 'row',
      alignItems: 'center',
      height: HEIGHT // width: '100%',

    }
  }, actions.add.visible && /*#__PURE__*/React.createElement(Button, {
    style: styles.button,
    accessoryLeft: props => /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
      name: "plus-circle"
    })),
    onPress: createOnActionCallback(EVENT.MODE_CHANGED, {
      value: [EDITOR_MODE.ADD, EDITOR_MODE.CONTINUES_ADD // @ts-ignore
      ].includes(mode) ? EDITOR_MODE.DEFAULT : EDITOR_MODE.ADD
    }),
    appearance: EDITOR_MODE.CONTINUES_ADD === mode ? 'filled' : 'outline',
    status: [EDITOR_MODE.ADD, EDITOR_MODE.CONTINUES_ADD // @ts-ignore
    ].includes(mode) ? 'warning' : 'primary',
    onLongPress: createOnActionCallback(EVENT.MODE_CHANGED, {
      value: EDITOR_MODE.CONTINUES_ADD
    })
  }, "Add"), actions.delete.visible && /*#__PURE__*/React.createElement(Button, {
    style: styles.button,
    accessoryLeft: leftProps => /*#__PURE__*/React.createElement(Icon, _extends({}, leftProps, {
      name: "delete-circle"
    })),
    status: [EDITOR_MODE.DELETE, EDITOR_MODE.CONTINUES_DELETE // @ts-ignore
    ].includes(mode) ? 'warning' : 'danger',
    appearance: EDITOR_MODE.CONTINUES_DELETE === mode ? 'filled' : 'outline',
    onPress: createOnActionCallback(EVENT.MODE_CHANGED, {
      value: [EDITOR_MODE.DELETE, EDITOR_MODE.CONTINUES_DELETE // @ts-ignore
      ].includes(mode) ? EDITOR_MODE.DEFAULT : EDITOR_MODE.DELETE
    }),
    onLongPress: createOnActionCallback(EVENT.MODE_CHANGED, {
      value: EDITOR_MODE.CONTINUES_DELETE
    })
  }, "Delete"), actions.layout.visible && /*#__PURE__*/React.createElement(LayoutOptions, {
    layout: graphConfig === null || graphConfig === void 0 ? void 0 : graphConfig.layout,
    createOnActionCallback: createOnActionCallback
  }), /*#__PURE__*/React.createElement(Recorder // @ts-ignore
  , {
    getStream: () => graphEditorRef.current.app.renderer.view.captureStream(25),
    render: ({
      startRecording,
      stopRecording,
      status
    }) => {
      if (recordingRef.current === RECORDING_STATUS_MAP.START) {
        recordingRef.current = RECORDING_STATUS_MAP.RECORDING;
        startRecording();
      }

      if (recordingRef.current === RECORDING_STATUS_MAP.STOP) {
        recordingRef.current = RECORDING_STATUS_MAP.IDLE;
        stopRecording();
      }

      return /*#__PURE__*/React.createElement(Icon, {
        name: "record-rec",
        color: status !== 'recording' ? 'black' : 'red',
        size: 32,
        onPress: createOnActionCallback(EVENT.TOGGLE_RECORD)
      });
    },
    onStop: (_, blob) => {
      createOnActionCallback(EVENT.RECORD_FINISHED, {
        value: blob
      })();
    }
  }), /*#__PURE__*/React.createElement(MoreOptions, {
    renderMoreAction: renderMoreAction,
    createOnActionCallback: createOnActionCallback,
    onAction: onAction
  })), /*#__PURE__*/React.createElement(Icon, {
    style: {
      position: 'absolute',
      left: 0,
      top: -24
    },
    name: "file-document-edit-outline",
    size: 24,
    onPress: createOnActionCallback(EVENT.TOGGLE_ACTION_BAR)
  }));
};

const OPTIONS = {
  Import: 'Import',
  Export: 'Export'
};

const MoreOptions = props => {
  const {
    renderMoreAction = () => /*#__PURE__*/React.createElement(View, null),
    createOnActionCallback,
    onAction
  } = props;
  const [state, setState] = React.useState({
    visible: false
  });
  return /*#__PURE__*/React.createElement(OverflowMenu, {
    anchor: anchorProps => /*#__PURE__*/React.createElement(Icon, _extends({}, anchorProps, {
      name: "dots-vertical",
      onPress: () => setState(_objectSpread(_objectSpread({}, state), {}, {
        visible: !state.visible
      }))
    })),
    visible: state.visible // selectedIndex={selectedIndex}
    ,
    onSelect: async indexPath => {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        visible: false
      }));
      const action = Object.values(OPTIONS)[indexPath.row];

      switch (action) {
        case OPTIONS.Import:
          {
            const result = await DocumentPicker.getDocumentAsync({
              type: 'application/json'
            });

            if (result.type === 'success') {
              const fileText = await readTextFile(result.file);
              createOnActionCallback(EVENT.IMPORT_DATA, {
                value: JSON.parse(fileText)
              })();
            }

            break;
          }

        case OPTIONS.Export:
          onAction({
            type: ACTION.EXPORT_DATA
          }); // createOnActionCallback(EVENT.EXPORT_DATA)()

          break;

        default:
          break;
      }
    },
    onBackdropPress: () => {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        visible: false
      }));
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, Object.values(OPTIONS).map(title => /*#__PURE__*/React.createElement(MenuItem, {
    title: title
  })), renderMoreAction()));
};

const LayoutOptions = props => {
  var _layout$animationDura;

  const {
    layout = {},
    createOnActionCallback
  } = props;
  const [state, setState] = React.useState({
    visible: false
  });
  const onItemSelect = React.useCallback(layoutName => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      visible: false
    }));
    createOnActionCallback(EVENT.LAYOUT_SELECTED, {
      value: layoutName
    })();
  }, [setState, createOnActionCallback]);
  const animationDuration = (_layout$animationDura = layout.animationDuration) !== null && _layout$animationDura !== void 0 ? _layout$animationDura : 5000;
  return /*#__PURE__*/React.createElement(Popover, {
    anchor: anchorProps => {
      var _layout$name;

      return /*#__PURE__*/React.createElement(View, anchorProps, /*#__PURE__*/React.createElement(SelectItem, {
        title: (_layout$name = layout.name) !== null && _layout$name !== void 0 ? _layout$name : 'Select Layout',
        onPress: () => setState(_objectSpread(_objectSpread({}, state), {}, {
          visible: !state.visible
        }))
      }));
    },
    visible: state.visible,
    onBackdropPress: () => setState(_objectSpread(_objectSpread({}, state), {}, {
      visible: false
    }))
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Form, {
    schema: {
      title: 'Layout',
      properties: {
        name: {
          type: 'string',
          enum: LAYOUT_NAMES
        },
        animationDuration: {
          type: 'number',
          minimum: 0,
          maximum: 10000
        },
        refresh: {
          type: 'number',
          minimum: 0,
          maximum: 100
        },
        maxIterations: {
          type: 'number',
          minimum: 0,
          maximum: 1000
        },
        maxSimulationTime: {
          type: 'number',
          minimum: 0,
          maximum: 1000
        }
      }
    },
    extraData: [layout],
    formData: {
      name: layout.name,
      animationDuration: layout.animationDuration,
      refresh: layout.refresh,
      maxIterations: layout.maxIterations,
      maxSimulationTime: layout.maxSimulationTime
    },
    onSubmit: formData => {
      createOnActionCallback(EVENT.LAYOUT_CHANGED, {
        value: formData
      })();
    }
  }))); // return (
  //   <Select
  //     selectedIndex={new IndexPath(selectedLayoutIndex)}
  //     onSelect={(index) => }
  // value={selectedLayoutIndex < 0
  //   ? 'Select Layout'
  //   : LAYOUT_NAMES[selectedLayoutIndex]}
  //   >
  //     <Card>
  //         <Text>{layout.animationDuration ?? 5000}</Text>
  //         <Slider
  //           value={layout.animationDuration}
  //           minimumValue={0}
  //           maximumValue={10000}
  //           onSlidingComplete={(animationDuration) => createOnActionCallback(
  //             EVENT.LAYOUT_ANIMATION_DURATION_CHANGED,
  //             {
  //               value: animationDuration,
  //             },
  //           )()}
  //         />
  //     </Card>
  //     {LAYOUT_NAMES.map((name) => (
  //       <SelectItem title={name} />
  //     ))}
  //   </Select>
  // )
};

export default wrapComponent(ActionBar, {});
const styles = StyleSheet.create({
  icon: {
    width: 24,
    height: 24,
    position: 'absolute',
    right: -24,
    top: 0
  },
  button: {
    marginRight: 10
  }
});